import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingContactButtons = () => {
  const phoneNumber = "918920808492";

  const buttonStyle = {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 6px 15px rgba(0,0,0,0.25)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    animation: "float 2s ease-in-out infinite",
  };

  return (
    <>
      {/* Animation CSS */}
      <style>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-6px);
          }
          100% {
            transform: translateY(0px);
          }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          right: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          flexDirection: "column", // Vertical
          gap: "15px",
          zIndex: 9999,
        }}
      >
        {/* Call Button */}
        <button
          onClick={() => (window.location.href = `tel:+${phoneNumber}`)}
          style={{
            ...buttonStyle,
            backgroundColor: "#007BFF",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <Phone size={28} />
        </button>

        {/* WhatsApp Button */}
        <button
          onClick={() =>
            window.open(
              `https://wa.me/${phoneNumber}?text=Hello`,
              "_blank"
            )
          }
          style={{
            ...buttonStyle,
            backgroundColor: "#25D366",
            animationDelay: "0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <FaWhatsapp size={28} />
        </button>
      </div>
    </>
  );
};

export default FloatingContactButtons;